exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\n  width: 50%;\n  max-width: 50%; }\n\n.modal-footer,\n.modal-body {\n  border-top: 1px solid #eceeef; }\n\n.modal-header {\n  padding: 10px 15px; }\n\n.modal-body {\n  padding: 25px 30px; }\n  .modal-body .question {\n    border-bottom: 1px solid #005aa9; }\n    .modal-body .question:last-of-type {\n      border-bottom: 0; }\n  .modal-body h2 {\n    font-size: 22px;\n    padding-top: 20px; }\n  .modal-body p {\n    padding-left: 15px; }\n  .modal-body ul {\n    padding-left: 25px;\n    list-style-type: none; }\n    .modal-body ul li {\n      padding: 5px 0;\n      font-size: 14px; }\n      .modal-body ul li div {\n        display: inline-block;\n        width: 30px; }\n        .modal-body ul li div i {\n          color: #8bd22f; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/stranka/FrontOffice/src/app/modals/survey-submission/survey-submission.scss
// module id = ../../../../../src/app/modals/survey-submission/survey-submission.scss
// module chunks = main